import React from 'react'

export const DownloadIcon = ({ ...props }) => {
    return (
        <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.50573 10.2186C2.05801 9.67343 2.26225 9.23149 2.9637 9.23149L15.8489 9.23149C16.5495 9.23149 16.756 9.67178 16.3069 10.2186L10.217 17.634C9.76925 18.1792 9.04472 18.1808 8.59564 17.634L2.50573 10.2186Z" fill="#6A6A63" />
            <path d="M1.47778 23.5H17.5222C18.3384 23.5 19 22.8326 19 22.0093C19 21.1859 18.3384 20.5185 17.5222 20.5185H1.47778C0.661623 20.5185 0 21.1859 0 22.0093C0 22.8326 0.661623 23.5 1.47778 23.5Z" fill="#6A6A63" />
            <path d="M7.17786 2.84261L7.17786 10.5093C7.17786 11.8031 8.21755 12.8519 9.50008 12.8519C10.7826 12.8519 11.8223 11.8031 11.8223 10.5093L11.8223 2.84261C11.8223 1.54883 10.7826 0.500014 9.50008 0.500014C8.21755 0.500014 7.17786 1.54883 7.17786 2.84261Z" fill="#6A6A63" />
        </svg>

    )
}
